import { Component, OnInit, Input } from '@angular/core';

import { PropertyService } from '../../services/property.service';
import { LesseeService } from '../../services/lessee.service';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-all-messages',
  templateUrl: './all-messages.component.html',
  styleUrls: ['./all-messages.component.scss']
})
export class AllMessagesComponent implements OnInit {
  @Input()
  property;

  conversations;

  constructor(private propertyService: PropertyService, private lesseeService: LesseeService, private authService: AuthService) { }

  ngOnInit() {
    if (this.authService.isAdmin()) {
      this.conversations = this.propertyService.getConversations(this.property);
    } else {
      if (this.property && this.property.id) {
        this.conversations = this.lesseeService.getConversations(this.property);
      }
    }
  }

  onCancel() {
    // Do nothing
  }

  onSend() {
    if (this.authService.isAdmin()) {
      this.conversations = this.propertyService.getConversations(this.property);
    } else {
      if (this.property && this.property.id) {
        this.conversations = this.lesseeService.getConversations(this.property);
      }
    }
  }
}
